<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">کیفیت رانندگی</div>
    <button class="back-btn" onclick="window.history.back()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>

  <div class="report-container" *ngIf="report?.length">
    <div class="card text-center">
      <i class="fa fa-bar-chart text-warning fa-2x"></i>
      <h4 class="text-center my-3">گزارش تحلیل رانندگی</h4>
      <h5 class="text-center">
        <small
          >{{ getValue("سفر", "زمان شروع") | date:"HH:mm:ss - yyyy/MM/dd" }} —
          {{ getValue("سفر", "زمان پایان") | date:"HH:mm:ss - yyyy/MM/dd" }}</small
        >
      </h5>
      <h5 class="text-center">
        تعداد نمونه: {{ getValue("آمار", "تعداد نمونه") }}
      </h5>
    </div>

    <!-- بخش امتیاز کلی -->
    <div class="card">
      <div class="overall-score-row">
        <div class="score-details">
          <h2 class="mb-4">امتیاز کل رانندگی شما</h2>
          <span
            class="status-badge mb-4"
            [ngClass]="
              getScoreBgClass(getNumericValue('امتیاز', 'امتیاز کل رانندگی'))
            "
          >
            <i class="fa fa-check-circle"></i>
            {{ getScoreStatus(getNumericValue("امتیاز", "امتیاز کل رانندگی")) }}
          </span>
        </div>
        <div
          class="score-circle"
          [ngClass]="
            getScoreColorClass(getNumericValue('امتیاز', 'امتیاز کل رانندگی'))
          "
        >
          <div class="score-value text-white">
            {{ getValue("امتیاز", "امتیاز کل رانندگی") }}
          </div>
          <div class="score-max text-white">از 100</div>
        </div>
      </div>
    </div>

    <!-- شاخص های جزئی -->
    <div class="sub-scores-grid">
      <!-- اعتماد تحلیل -->
      <div class="sub-score-item py-4">
        <span class="sub-title">اعتماد تحلیل</span>
        <span class="sub-icon pt-4">
          <i
            class="fa fa-signal fa-2x"
            [ngClass]="
              getScoreColorClass(getNumericValue('امتیاز', 'اعتماد تحلیل'))
            "
          ></i>
        </span>
        <div class="py-3 d-flex flex-column">
          <span class="sub-val">{{ getValue("امتیاز", "اعتماد تحلیل") }}</span>
          <small class="text-muted">از 100</small>
        </div>
        <span
          class="sub-status fw-bold"
          [ngClass]="
            getScoreColorClass(getNumericValue('امتیاز', 'اعتماد تحلیل'))
          "
        >
          {{ getScoreStatus(getNumericValue("امتیاز", "اعتماد تحلیل")) }}
        </span>
      </div>

      <!-- سلامت موتور -->
      <div class="sub-score-item py-4">
        <span class="sub-title">سلامت موتور</span>
        <span class="sub-icon pt-4">
          <i
            class="fa fa-wrench fa-2x"
            [ngClass]="
              getScoreColorClass(getNumericValue('امتیاز', 'سلامت موتور'))
            "
          ></i>
        </span>
        <div class="py-3 d-flex flex-column">
          <span class="sub-val">{{ getValue("امتیاز", "سلامت موتور") }}</span>
          <small class="text-muted">از 100</small>
        </div>
        <span
          class="sub-status fw-bold"
          [ngClass]="
            getScoreColorClass(getNumericValue('امتیاز', 'سلامت موتور'))
          "
        >
          {{ getScoreStatus(getNumericValue("امتیاز", "سلامت موتور")) }}
        </span>
      </div>

      <!-- رانندگی اقتصادی -->
      <div class="sub-score-item py-4">
        <span class="sub-title">رانندگی اقتصادی</span>
        <span class="sub-icon pt-4">
          <i
            class="fa fa-leaf fa-2x"
            [ngClass]="
              getScoreColorClass(getNumericValue('امتیاز', 'رانندگی اقتصادی'))
            "
          ></i>
        </span>
        <div class="py-3 d-flex flex-column">
          <span class="sub-val">{{
            getValue("امتیاز", "رانندگی اقتصادی")
          }}</span>
          <small class="text-muted">از 100</small>
        </div>
        <span
          class="sub-status fw-bold"
          [ngClass]="
            getScoreColorClass(getNumericValue('امتیاز', 'رانندگی اقتصادی'))
          "
        >
          {{ getScoreStatus(getNumericValue("امتیاز", "رانندگی اقتصادی")) }}
        </span>
      </div>

      <!-- ایمنی رانندگی -->
      <div class="sub-score-item py-4">
        <span class="sub-title">ایمنی رانندگی</span>
        <span class="sub-icon pt-4">
          <i
            class="fa fa-shield fa-2x"
            [ngClass]="
              getScoreColorClass(getNumericValue('امتیاز', 'ایمنی رانندگی'))
            "
          ></i>
        </span>
        <div class="py-3 d-flex flex-column">
          <span class="sub-val">{{ getValue("امتیاز", "ایمنی رانندگی") }}</span>
          <small class="text-muted">از 100</small>
        </div>
        <span
          class="sub-status fw-bold"
          [ngClass]="
            getScoreColorClass(getNumericValue('امتیاز', 'ایمنی رانندگی'))
          "
        >
          {{ getScoreStatus(getNumericValue("امتیاز", "ایمنی رانندگی")) }}
        </span>
      </div>
    </div>

    <!-- خلاصه سفر -->
    <div class="card summary-card">
      <div class="card-header">
        <h3>خلاصه سفر</h3>
      </div>
      <div class="summary-grid">
        <div class="summary-item">
          <i class="fa fa-clock-o text-blue"></i>
          <span class="title">مدت رانندگی واقعی</span>
          <span class="val">{{ getValue("سفر", "مدت رانندگی واقعی") }}</span>
        </div>
        <div class="summary-item">
          <i class="fa fa-tachometer text-green"></i>
          <span class="title">سرعت متوسط</span>
          <span class="val">{{ getValue("آمار", "سرعت متوسط") }}</span>
        </div>
        <div class="summary-item">
          <i class="fa fa-arrow-up text-orange"></i>
          <span class="title">حداکثر سرعت</span>
          <span class="val">{{ getValue("آمار", "حداکثر سرعت") }}</span>
        </div>
        <div class="summary-item">
          <i class="fa fa-tachometer text-blue"></i>
          <span class="title">حداکثر دور موتور</span>
          <span class="val">{{ getValue("آمار", "حداکثر دور موتور") }}</span>
        </div>
      </div>
    </div>

    <!-- رویداد و موتور -->
    <div class="events-engine-grid">
      <!-- ستون موتور -->
      <div class="card list-card">
        <div class="card-header">
          <h3>سلامت موتور</h3>
        </div>
        <ul class="list">
          <li>
            <div class="list-title">
              <i
                class="fa fa-dashboard"
                [ngClass]="
                  getEventColorClass(
                    getNumericValue('موتور', 'نمونه های دور موتور بالا')
                  )
                "
              ></i
              ><span>نمونه‌های دور موتور بالا</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(
                  getNumericValue('موتور', 'نمونه های دور موتور بالا')
                )
              "
            >
              {{ getValue("موتور", "نمونه های دور موتور بالا") }} بار
            </div>
          </li>
          <li>
            <div class="list-title">
              <i
                class="fa fa-cogs"
                [ngClass]="
                  getEventColorClass(
                    getNumericValue('موتور', 'نمونه های بار موتور بالا')
                  )
                "
              ></i
              ><span>نمونه‌های بار موتور بالا</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(
                  getNumericValue('موتور', 'نمونه های بار موتور بالا')
                )
              "
            >
              {{ getValue("موتور", "نمونه های بار موتور بالا") }} بار
            </div>
          </li>
          <li>
            <div class="list-title">
              <i
                class="fa fa-thermometer-full"
                [ngClass]="
                  getEventColorClass(
                    getNumericValue('موتور', 'نمونه های دمای بالا')
                  )
                "
              ></i
              ><span>نمونه‌های دمای بالا</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(
                  getNumericValue('موتور', 'نمونه های دمای بالا')
                )
              "
            >
              {{ getValue("موتور", "نمونه های دمای بالا") }} بار
            </div>
          </li>
          <li>
            <p
              class="fw-bold"
              [ngClass]="
                getScoreColorClass(getNumericValue('امتیاز', 'سلامت موتور'))
              "
            >
              وضعیت موتور در سفر
              {{ getScoreStatus(getNumericValue("امتیاز", "سلامت موتور")) }}
              است.
            </p>
          </li>
        </ul>
      </div>
      <!-- ستون رویداد -->
      <div class="card list-card">
        <div class="card-header">
          <h3>رویدادها</h3>
        </div>
        <ul class="list">
          <li>
            <div class="list-title">
              <i
                class="fa fa-forward"
                [ngClass]="
                  getEventColorClass(
                    getNumericValue('رویداد', 'تعداد شتاب شدید')
                  )
                "
              ></i
              ><span>تعداد شتاب شدید</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(getNumericValue('رویداد', 'تعداد شتاب شدید'))
              "
            >
              {{ getValue("رویداد", "تعداد شتاب شدید") }} بار
            </div>
          </li>
          <li>
            <div class="list-title">
              <i
                class="fa fa-stop-circle"
                [ngClass]="
                  getEventColorClass(
                    getNumericValue('رویداد', 'تعداد ترمز شدید')
                  )
                "
              ></i
              ><span>تعداد ترمز شدید</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(getNumericValue('رویداد', 'تعداد ترمز شدید'))
              "
            >
              {{ getValue("رویداد", "تعداد ترمز شدید") }} بار
            </div>
          </li>
          <li>
            <div class="list-title">
              <i
                class="fa fa-tachometer"
                [ngClass]="
                  getEventColorClass(getNumericValue('رویداد', 'سرعت غیرمجاز'))
                "
              ></i
              ><span>سرعت غیرمجاز</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getEventColorClass(getNumericValue('رویداد', 'سرعت غیرمجاز'))
              "
            >
              {{ getValue("رویداد", "سرعت غیرمجاز") }} بار
            </div>
          </li>
          <li>
            <div class="list-title">
              <i
                class="fa fa-hourglass-half"
                [ngClass]="
                  getIdleTimeColorClass(getNumericValue('رویداد', 'زمان درجا'))
                "
              ></i
              ><span>زمان درجا</span>
            </div>
            <div
              class="list-val"
              [ngClass]="
                getIdleTimeColorClass(getNumericValue('رویداد', 'زمان درجا'))
              "
            >
              {{ getValue("رویداد", "زمان درجا") }}
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- پیشنهادها -->
    <div class="suggestions-section">
      <div class="card">
        <div class="section-title mb-3">
          <i class="fa fa-lightbulb-o text-orange"></i>
          <h3>پیشنهادها برای شما</h3>
        </div>

        <div
          *ngFor="let sug of getSuggestions()"
          class="suggestion-card mb-2"
          [ngClass]="getSuggestionBgClass(sug.Severity)"
        >
          <div class="sug-icon">
            <i
              class="fa"
              [ngClass]="[
                getSuggestionIcon(sug.Severity),
                getSuggestionColorClass(sug.Severity),
              ]"
            ></i>
          </div>
          <div class="sug-content">
            <h4>{{ sug.Title }}</h4>
            <p>{{ sug.Value }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- جمع بندی نهایی -->
    <div class="card">
      <div class="overall-score-row">
        <div class="score-details">
          <h2 class="mb-4">
            <i class="fa fa-trophy text-blue"></i>
            جمع بندی نهایی
          </h2>
          <p>
            وضعیت رانندگی شما:
            <span
              class="status-badge"
              [ngClass]="
                getScoreBgClass(getNumericValue('امتیاز', 'امتیاز کل رانندگی'))
              "
              >{{ getValue("جمع بندی", "وضعیت رانندگی") }}</span
            >
          </p>
        </div>
        <div class="score-circle text-blue">
          <div class="score-value text-white">
            {{ getValue("امتیاز", "امتیاز کل رانندگی") }}
          </div>
          <div class="score-max text-white">از 100</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="dateTimeModal"
  data-backdrop="false"
  data-bs-backdrop="static"
  data-keyboard="false"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content dirI">
      <div class="modal-header dirI">
        <h5 class="modal-title" id="exampleModalLabel">
          بازه زمانی را مشخص کنید
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body">
        <div [formGroup]="searchForm" class="container-fluid row gx-2 gy-2">
          <div class="col-12 col-md-6 position-relative">
            <label> از تاریخ </label>
            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [dateFormat]="'jYYYY/jMM/jDD HH:mm:ss'"
            >
              <input formControlName="strSTime" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>
          <div class="col-12 col-md-6 position-relative">
            <label> تا تاریخ </label>
            <ng-persian-datepicker
              [uiTheme]="'gray'"
              [dateFormat]="'jYYYY/jMM/jDD HH:mm:ss'"
            >
              <input formControlName="strETime" class="form-control text-end" />
            </ng-persian-datepicker>
          </div>
        </div>
      </div>

      <div class="modal-footer d-flex justify-content-start">
        <button class="btn btn-success" (click)="fetchData()">
          &nbsp; &nbsp; تایید &nbsp; &nbsp;
        </button>
      </div>
    </div>
  </div>
</div>
